const e = {
  "pipeline-changes-track": "pipeline-changes-track",
  "pipeline-changes-track__lane": "pipeline-changes-track__lane",
  "pipeline-changes-track__lane--current": "pipeline-changes-track__lane--current",
  "pipeline-changes-track__lane--previous": "pipeline-changes-track__lane--previous",
  "pipeline-changes-track__lane--passed": "pipeline-changes-track__lane--passed",
  "pipeline-changes-track__lane--future": "pipeline-changes-track__lane--future",
  "pipeline-changes-track__cell": "pipeline-changes-track__cell",
  "pipeline-changes-track__cell--future": "pipeline-changes-track__cell--future",
  "pipeline-changes-track__cell--passed": "pipeline-changes-track__cell--passed",
  "pipeline-changes-track--oncology-hematology": "pipeline-changes-track--oncology-hematology",
  "pipeline-changes-track--ophthalmology": "pipeline-changes-track--ophthalmology",
  "pipeline-changes-track--neuroscience": "pipeline-changes-track--neuroscience",
  "pipeline-changes-track--cardiovascular": "pipeline-changes-track--cardiovascular",
  "pipeline-changes-track--immunology": "pipeline-changes-track--immunology",
  "pipeline-changes-track--infectious-diseases": "pipeline-changes-track--infectious-diseases",
  "pipeline-changes-track--other": "pipeline-changes-track--other"
};
export {
  e as default
};
